import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type DateTimeService from '@/services/dateTimeService'
import type { MessageSendRepeatFormScheme } from '@/services/domain/messages/types'

@injectable()
export default class ComposeScheduledInitFormData {
  constructor(@inject(SERVICE_TYPES.DateTimeService) protected readonly dateTimeService: DateTimeService) {}

  public getMessageSendRepeatInitFormData(): MessageSendRepeatFormScheme {
    return {
      type: 'none',
      end: {
        type: 'never',
        smsSessions: 1,
        date: this.dateTimeService.formatDate(
          this.dateTimeService.addDays(this.dateTimeService.now(), 1),
          'yyyy-MM-dd',
        ),
      },
      hourly: {
        count: 1,
      },
      daily: {
        count: 1,
      },
      weekly: {
        count: 1,
        days: [],
      },
      monthly: {
        count: 1,
        repeat: 'month-day',
        monthDay: '1',
        firstLastDay: 'First',
        weekDay: 'Sunday',
      },
      yearly: {
        count: 1,
        type: 'year-day',
        month: 'January',
        monthDay: '1',
        firstLastDay: 'First',
        weekDay: 'Sunday',
        dayOfMonth: 'January',
      },
    }
  }
}
